require("dotenv").config();
// let host = "https://tapi.alobhatech.com";
let host = "https://www.alobhaapi.alobhatech.com";

export const getHomePageMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-home-page-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setHomePageMetaData(metaData));
                    // console.log("Home meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setHomePageMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_HOME_PAGE_METADATA",
            payload: metaData,
        }
    }
}


export const getAboutusPageMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-aboutus-page-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setAboutusPageMetaData(metaData));
                    // console.log("About us meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setAboutusPageMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_ABOUTUS_PAGE_METADATA",
            payload: metaData,
        }
    }
}


export const getServicesPageMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-services-page-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setServicesPageMetaData(metaData));
                    // console.log("Services meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setServicesPageMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_SERVICES_PAGE_METADATA",
            payload: metaData,
        }
    }
}


export const getCareerPageMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-career-page-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setCareerPageMetaData(metaData));
                    // console.log("Career meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setCareerPageMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_CAREER_PAGE_METADATA",
            payload: metaData,
        }
    }
}

export const getPortfolioMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-portfolio-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setPortfolioMetaData(metaData));
                    // console.log("Portfolio Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setPortfolioMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_PORTFOLIO_METADATA",
            payload: metaData,
        }
    }
}


export const getContactusPageMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-contactus-page-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setContactusPageMetaData(metaData));
                    // console.log("Contact us meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setContactusPageMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_CONTACTUS_PAGE_METADATA",
            payload: metaData,
        }
    }
}


export const getOutsourcingSoftwareDevelopmentMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-outsourcing-software-development-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setOutsourcingSoftwareDevelopmentMetaData(metaData));
                    // console.log("Outsourcing Software Development meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setOutsourcingSoftwareDevelopmentMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_OUTSOURCING_SOFTWARE_DEVELOPMENT_METADATA",
            payload: metaData,
        }
    }
}


export const getMobileAppDevelopmentMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-mobile-app-development-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setMobileAppDevelopmentMetaData(metaData));
                    // console.log("Mobile App Development meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setMobileAppDevelopmentMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_MOBILE_APP_DEVELOPMENT_METADATA",
            payload: metaData,
        }
    }
}


export const getWebDevelopmentMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-web-development-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setWebDevelopmentMetaData(metaData));
                    // console.log("Web Development meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setWebDevelopmentMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_WEB_DEVELOPMENT_METADATA",
            payload: metaData,
        }
    }
}


export const getCMSMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-cms-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setCMSMetaData(metaData));
                    // console.log("CMS meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setCMSMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_CMS_METADATA",
            payload: metaData,
        }
    }
}


export const getERPMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-erp-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setERPMetaData(metaData));
                    // console.log("ERP meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setERPMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_ERP_METADATA",
            payload: metaData,
        }
    }
}


export const getIOTMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-iot-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setIOTMetaData(metaData));
                    // console.log("IOT meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setIOTMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_IOT_METADATA",
            payload: metaData,
        }
    }
}


export const getMLMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-machine-learning-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setMLMetaData(metaData));
                    // console.log("ML meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setMLMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_ML_METADATA",
            payload: metaData,
        }
    }
}


export const getDigitalMarketingMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-digital-marketing-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setDigitalMarketingMetaData(metaData));
                    // console.log("Digital Marketing meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setDigitalMarketingMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_DIGITAL_MARKETING_METADATA",
            payload: metaData,
        }
    }
}



export const getIVRMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-ivr-services-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setIVRMetaData(metaData));
                    // console.log("IVR meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setIVRMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_IVR_METADATA",
            payload: metaData,
        }
    }
}



export const getDotNetMetaData = () => {
    return async function (dispatch) {
        await fetch(`${host}/get-dot-net-technology-development-meta-data`, { method: "GET" })
            .then((res) => {
                res.json().then((metaData) => {
                    dispatch(setDotNetMetaData(metaData));
                    // console.log("Dot net meta Data in dispatch action:", metaData);
                })
            }).catch((err)=>{
                console.log("ERROR:",err.message,err);
            })

    }
}

export const setDotNetMetaData = (metaData) => {
    if (metaData) {
        return {
            type: "SET_DOT_NET_METADATA",
            payload: metaData,
        }
    }
}